import { useContext } from 'react';
import { RoleContext } from '../contexts/RoleContext';

export const useRoleContext = () => {
  const context = useContext(RoleContext);
  if (context === undefined) {
    throw new Error('useRoleContext must be used within a RoleProvider');
  }
  return context;
}; 